﻿  (function () {
    function preloadImage(src) {
      return new Promise(function (resolve) {
        if (!src) return resolve();
        var img = new Image();
        img.onload = resolve;
        img.onerror = resolve;
        img.decoding = 'async';
        img.src = src;
      });
    }

    function waitForImage(imgEl) {
      return new Promise(function (resolve) {
        if (!imgEl) return resolve();
        if (imgEl.complete && imgEl.naturalWidth > 0) return resolve();
        function done() {
          imgEl.removeEventListener('load', done);
          imgEl.removeEventListener('error', done);
          resolve();
        }
        imgEl.addEventListener('load', done);
        imgEl.addEventListener('error', done);
      });
    }

    function uniq(arr) {
      var out = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] && out.indexOf(arr[i]) === -1) out.push(arr[i]);
      }
      return out;
    }

    function setupCardCarousel(card) {
      if (!card || card.getAttribute('data-uf-carousel-bound') === '1') return null;
      card.setAttribute('data-uf-carousel-bound', '1');

      var firstImg = card.querySelector('.grid__image .first--image') || card.querySelector('.grid__image img');
      if (!firstImg) return null;

      var secondImg = card.querySelector('.grid__image .second--image');
      var prevBtn = card.querySelector('.uf-card-nav--prev');
      var nextBtn = card.querySelector('.uf-card-nav--next');

      var mainSrc = firstImg.getAttribute('data-primary-src') || firstImg.getAttribute('data-src') || firstImg.getAttribute('src') || '';
      var hoverSrc = secondImg ? (secondImg.getAttribute('data-src') || secondImg.getAttribute('src') || '') : '';
      var raw = (card.getAttribute('data-product-images') || '').split('||');
      var rawU = uniq(
        raw.filter(function (s) {
          return s && String(s).trim();
        })
      );

      /**
       * Hover-IMG gebruikt 275x in data-src; data-product-images bevat 600x voor alle varianten.
       * Daardoor matcht de 2e foto-URL niet met hoverSrc â†’ filter laat 1 item over â†’ pijlen doen niets.
       * Bij precies 2 unieke URL's in data-product-images: carousel altijd op die twee (600x).
       */
      var extraSources;
      if (rawU.length === 2) {
        extraSources = rawU.slice();
      } else {
        extraSources = rawU.filter(function (src) {
          return src && src !== mainSrc && src !== hoverSrc;
        });
        if (!extraSources.length && hoverSrc && hoverSrc !== mainSrc) {
          extraSources = [mainSrc, hoverSrc];
        } else if (!extraSources.length && hoverSrc) {
          extraSources = [hoverSrc];
        }
      }

      var state = {
        index: 0,
        isHoverFrame: false,
        /** Alleen true na klik op carousel-pijlen; anders altijd main bij geen hover */
        carouselActive: false,
        main: mainSrc,
        hover: hoverSrc,
        list: extraSources
      };

      function render() {
        var src = '';
        if (state.isHoverFrame && state.hover) {
          src = state.hover;
        } else if (state.carouselActive && state.list.length) {
          src = state.list[state.index % state.list.length];
        } else {
          src = state.main;
        }
        if (!src) return;
        firstImg.setAttribute('src', src);
        firstImg.setAttribute('data-src', src);
      }

      function stopLinkNav(e) {
        e.preventDefault();
        e.stopPropagation();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          stopLinkNav(e);
          if (!state.list.length) return;
          state.carouselActive = true;
          if (state.isHoverFrame) {
            state.isHoverFrame = false;
            state.index = state.list.length - 1;
          }
          state.index = (state.index - 1 + state.list.length) % state.list.length;
          render();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          stopLinkNav(e);
          if (!state.list.length) return;
          state.carouselActive = true;
          if (state.isHoverFrame) {
            state.isHoverFrame = false;
            state.index = state.list.length - 1;
          }
          state.index = (state.index + 1) % state.list.length;
          render();
        });
      }

      card.addEventListener('mouseenter', function () {
        state.isHoverFrame = !!state.hover;
        render();
      });

      card.addEventListener('mouseleave', function () {
        state.isHoverFrame = false;
        state.carouselActive = false;
        state.index = 0;
        firstImg.setAttribute('src', state.main);
        firstImg.setAttribute('data-src', state.main);
        render();
      });

      return {
        firstImg: firstImg,
        mainSrc: mainSrc,
        hoverSrc: hoverSrc,
        extraSources: extraSources
      };
    }

    function init() {
      var cards = Array.prototype.slice.call(document.querySelectorAll('.collection_page .grid__item[data-product-images]'));
      if (!cards.length) return;

      var states = [];
      for (var i = 0; i < cards.length; i++) {
        var st = setupCardCarousel(cards[i]);
        if (st) states.push(st);
      }

      // Loading strategy:
      // 1) quick preview image is already visible from markup
      // 2) upgrade primary images to sharp version in background
      // 3) preload hover image for each card
      // 4) preload all remaining carousel images in background
      Promise.all(cards.map(function (card) {
        return waitForImage(card.querySelector('.grid__image .first--image') || card.querySelector('.grid__image img'));
      }))
      .then(function () {
        var queue = states
          .map(function (s) { return s && s.mainSrc ? s : null; })
          .filter(Boolean);
        var idx = 0;
        var active = 0;
        var maxConcurrent = 3;
        return new Promise(function (resolve) {
          function pump() {
            while (active < maxConcurrent && idx < queue.length) {
              var item = queue[idx++];
              active++;
              (function (it) {
                preloadImage(it.mainSrc).then(function () {
                  try {
                    if (it.firstImg && it.mainSrc) {
                      it.firstImg.setAttribute('src', it.mainSrc);
                      it.firstImg.setAttribute('data-src', it.mainSrc);
                    }
                  } catch (e) {}
                  active--;
                  if (idx >= queue.length && active === 0) resolve();
                  else pump();
                });
              }(item));
            }
            if (idx >= queue.length && active === 0) resolve();
          }
          setTimeout(pump, 0);
        });
      })
      .then(function () {
        return Promise.all(states.map(function (s) { return preloadImage(s.hoverSrc); }));
      })
      .then(function () {
        var queue = [];
        states.forEach(function (s) {
          (s.extraSources || []).forEach(function (src) { queue.push(src); });
        });
        queue = uniq(queue);

        var idx = 0;
        var active = 0;
        var maxConcurrent = 4;

        function pump() {
          while (active < maxConcurrent && idx < queue.length) {
            var src = queue[idx++];
            active++;
            preloadImage(src).then(function () {
              active--;
              pump();
            });
          }
        }
        setTimeout(pump, 60);
      });
    }

    window.ufCollectionGridCardsInit = init;

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
